// Sugalarm — three-state speaker icon for the kiosk volume button.
//
// muted     → speaker body + a red "no" circle-slash through it (cycle
//             333 — was a bare currentColor line; now the standard
//             prohibition-sign treatment, in the token red --zone-urgent
//             so it reads as "blocked" distinctly from the ink-colored
//             speaker underneath, on every theme)
// level=0   → speaker body, no waves
// 0<lvl<=50 → speaker body + one wave
// level>50  → speaker body + two waves
//
// Co-located with SpeakerIcon (TTS button) but deliberately separate;
// the TTS button keeps using SpeakerIcon untouched.

interface Props {
  level: number;
  muted: boolean;
  size?: number;
}

export function VolumeIcon({ level, muted, size = 14 }: Props) {
  const showWave1 = !muted && level > 0;
  const showWave2 = !muted && level > 50;
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      stroke="currentColor"
      strokeWidth={1.6}
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M3 6 H5 L9 3 V13 L5 10 H3 Z" fill="currentColor" stroke="none" />
      {showWave1 && <path d="M11.5 5.5 C 12.8 6.7, 12.8 9.3, 11.5 10.5" />}
      {showWave2 && (
        <path d="M13.5 3.5 C 16 5.5, 16 10.5, 13.5 12.5" opacity={0.6} />
      )}
      {muted && (
        <g stroke="var(--zone-urgent)" strokeWidth={1.6}>
          <circle cx="8" cy="8" r="6.2" fill="none" />
          <path d="M3.6 3.6 L12.4 12.4" />
        </g>
      )}
    </svg>
  );
}
